import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/store";
import i18n from "./i18n";
import Notifications from "@kyvg/vue3-notification";
import velocity from "velocity-animate";
import VueCookies from "vue-cookies";
import { commonUtil, MatchUtil } from "./store/utils";
import WebSocketService from "./socket";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faStepForward,
  faStepBackward,
  faBackward,
  faForward,
  faLock,
  faKey,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "vuetify/styles";

const vuetify = createVuetify({
  components,
  directives,
});

library.add(
  faStepForward,
  faStepBackward,
  faBackward,
  faForward,
  faLock,
  faKey,
  faPlus,
);

const isProd = process.env.NODE_ENV === "production";

const app = createApp(App);
app.component("FontAwesomeIcon", FontAwesomeIcon);
app.use(Notifications, { velocity });
app.use(VueCookies);
app.use(vuetify);
app.use(router);
app.use(store);
app.use(i18n);

app.config.globalProperties.$utils = {
  match: MatchUtil,
  common: commonUtil,
};

// A-10: глобальная проверка права в шаблонах — $can('LIVE_VIEW')
app.config.globalProperties.$can = (key) => store.getters.hasPermission(key);

// A-10: директива v-can="'KEY'" — простое скрытие элемента при отсутствии права
app.directive("can", {
  mounted(el, binding) {
    if (!store.getters.hasPermission(binding.value)) el.style.display = "none";
  },
  updated(el, binding) {
    el.style.display = store.getters.hasPermission(binding.value) ? "" : "none";
  },
});

// ініціалізація WebSocket
// WebSocketService.init().then(() => {
//   console.log('WebSocket connected')
// }).catch(() => {
//   console.error('Failed to connect to WebSocket')
// })

app.config.productionTip = isProd;
app.config.devtools = !isProd;

app.mount("#app");
